export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  I18NLocaleCode: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Time: { input: any; output: any; }
};

export type A11YStatement = {
  __typename?: 'A11YStatement';
  contactPreface?: Maybe<Scalars['String']['output']>;
  contactPrefaceTitle?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  footer?: Maybe<Scalars['String']['output']>;
  hasChanges: Scalars['Boolean']['output'];
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type A11YStatementInput = {
  contactPreface?: InputMaybe<Scalars['String']['input']>;
  contactPrefaceTitle?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Announcement = {
  __typename?: 'Announcement';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dismissalVersion?: Maybe<Scalars['Int']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  link?: Maybe<ComponentLinksLink>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<Announcement>>;
  localizations_connection?: Maybe<AnnouncementRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnnouncementInput = {
  dismissalVersion?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<ComponentLinksLinkInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AnnouncementRelationResponseCollection = {
  __typename?: 'AnnouncementRelationResponseCollection';
  nodes: Array<Announcement>;
};

export type AuthenticPlace = {
  __typename?: 'AuthenticPlace';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  flyer: UploadFile;
  hasChanges: Scalars['Boolean']['output'];
  image: UploadFile;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<AuthenticPlace>>;
  localizations_connection?: Maybe<AuthenticPlaceRelationResponseCollection>;
  location: ComponentLocationsLocation;
  order: Scalars['Int']['output'];
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  routeDescription: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type AuthenticPlaceLocalizationsArgs = {
  filters?: InputMaybe<AuthenticPlaceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AuthenticPlaceLocalizations_ConnectionArgs = {
  filters?: InputMaybe<AuthenticPlaceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AuthenticPlaceEntityResponseCollection = {
  __typename?: 'AuthenticPlaceEntityResponseCollection';
  nodes: Array<AuthenticPlace>;
  pageInfo: Pagination;
};

export type AuthenticPlaceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AuthenticPlaceFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<AuthenticPlaceFiltersInput>;
  location?: InputMaybe<ComponentLocationsLocationFiltersInput>;
  not?: InputMaybe<AuthenticPlaceFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AuthenticPlaceFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  routeDescription?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type AuthenticPlaceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  flyer?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<ComponentLocationsLocationInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  routeDescription?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AuthenticPlaceRelationResponseCollection = {
  __typename?: 'AuthenticPlaceRelationResponseCollection';
  nodes: Array<AuthenticPlace>;
};

export type AuthenticPlacesContent = {
  __typename?: 'AuthenticPlacesContent';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  hero: ComponentHeroHero;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<AuthenticPlacesContent>>;
  localizations_connection?: Maybe<AuthenticPlacesContentRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AuthenticPlacesContentInput = {
  hero?: InputMaybe<ComponentHeroHeroInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuthenticPlacesContentRelationResponseCollection = {
  __typename?: 'AuthenticPlacesContentRelationResponseCollection';
  nodes: Array<AuthenticPlacesContent>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentA11Ya11YFeature = {
  __typename?: 'ComponentA11YA11YFeature';
  description: Scalars['String']['output'];
  iconName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentA11Ya11YFeatureFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentA11Ya11YFeatureFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  iconName?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentA11Ya11YFeatureFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentA11Ya11YFeatureFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentA11Ya11YFeatureInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  iconName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentContactAddress = {
  __typename?: 'ComponentContactAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type ComponentContactAddressFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentContactAddressFiltersInput>>>;
  city?: InputMaybe<StringFilterInput>;
  country?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentContactAddressFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentContactAddressFiltersInput>>>;
  state?: InputMaybe<StringFilterInput>;
  street?: InputMaybe<StringFilterInput>;
  zipCode?: InputMaybe<StringFilterInput>;
};

export type ComponentContactAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentContactPhone = {
  __typename?: 'ComponentContactPhone';
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  reachabilityHint?: Maybe<Scalars['String']['output']>;
};

export type ComponentContactPhoneContact = {
  __typename?: 'ComponentContactPhoneContact';
  contactTimes?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phone: ComponentContactPhone;
};

export type ComponentContactPhoneFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentContactPhoneFiltersInput>>>;
  not?: InputMaybe<ComponentContactPhoneFiltersInput>;
  number?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentContactPhoneFiltersInput>>>;
  reachabilityHint?: InputMaybe<StringFilterInput>;
};

export type ComponentContactPhoneInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  reachabilityHint?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentGeneralDetail = {
  __typename?: 'ComponentGeneralDetail';
  description?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<ComponentGeneralOrdinalMedia>>>;
  documents_old: Array<Maybe<UploadFile>>;
  documents_old_connection?: Maybe<UploadFileRelationResponseCollection>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFile>;
  imagePosition?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Maybe<ComponentLinksLink>>>;
  splitInitial?: Maybe<Scalars['Float']['output']>;
  splitMax?: Maybe<Scalars['Float']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  viewVariant: Enum_Componentgeneraldetail_Viewvariant;
};


export type ComponentGeneralDetailDocumentsArgs = {
  filters?: InputMaybe<ComponentGeneralOrdinalMediaFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentGeneralDetailDocuments_OldArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentGeneralDetailDocuments_Old_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentGeneralDetailLinksArgs = {
  filters?: InputMaybe<ComponentLinksLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentGeneralDetailFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentGeneralDetailFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  documents?: InputMaybe<ComponentGeneralOrdinalMediaFiltersInput>;
  imagePosition?: InputMaybe<StringFilterInput>;
  links?: InputMaybe<ComponentLinksLinkFiltersInput>;
  not?: InputMaybe<ComponentGeneralDetailFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentGeneralDetailFiltersInput>>>;
  splitInitial?: InputMaybe<FloatFilterInput>;
  splitMax?: InputMaybe<FloatFilterInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  viewVariant?: InputMaybe<StringFilterInput>;
};

export type ComponentGeneralDetailInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<InputMaybe<ComponentGeneralOrdinalMediaInput>>>;
  documents_old?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  imagePosition?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<ComponentLinksLinkInput>>>;
  splitInitial?: InputMaybe<Scalars['Float']['input']>;
  splitMax?: InputMaybe<Scalars['Float']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  viewVariant?: InputMaybe<Enum_Componentgeneraldetail_Viewvariant>;
};

export type ComponentGeneralOrdinalMedia = {
  __typename?: 'ComponentGeneralOrdinalMedia';
  id: Scalars['ID']['output'];
  media?: Maybe<UploadFile>;
  order: Scalars['Int']['output'];
};

export type ComponentGeneralOrdinalMediaFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentGeneralOrdinalMediaFiltersInput>>>;
  not?: InputMaybe<ComponentGeneralOrdinalMediaFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentGeneralOrdinalMediaFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
};

export type ComponentGeneralOrdinalMediaInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type ComponentGeneralPictogram = {
  __typename?: 'ComponentGeneralPictogram';
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type ComponentGeneralPictogramFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentGeneralPictogramFiltersInput>>>;
  icon?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentGeneralPictogramFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentGeneralPictogramFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentGeneralPictogramInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentGeneralPrice = {
  __typename?: 'ComponentGeneralPrice';
  currency: Enum_Componentgeneralprice_Currency;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  purpose?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export type ComponentGeneralPriceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentGeneralPriceFiltersInput>>>;
  currency?: InputMaybe<StringFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentGeneralPriceFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentGeneralPriceFiltersInput>>>;
  purpose?: InputMaybe<StringFilterInput>;
  value?: InputMaybe<FloatFilterInput>;
};

export type ComponentGeneralPriceInput = {
  currency?: InputMaybe<Enum_Componentgeneralprice_Currency>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type ComponentGeneralShowpieces = {
  __typename?: 'ComponentGeneralShowpieces';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images: Array<Maybe<UploadFile>>;
  images_connection: UploadFileRelationResponseCollection;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentGeneralShowpiecesImagesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentGeneralShowpiecesImages_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentGeneralShowpiecesInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentGeneralWeekdays = {
  __typename?: 'ComponentGeneralWeekdays';
  Friday: Scalars['Boolean']['output'];
  Monday: Scalars['Boolean']['output'];
  Saturday: Scalars['Boolean']['output'];
  Sunday: Scalars['Boolean']['output'];
  Thursday: Scalars['Boolean']['output'];
  Tuesday: Scalars['Boolean']['output'];
  Wednesday: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentGeneralWeekdaysFiltersInput = {
  Friday?: InputMaybe<BooleanFilterInput>;
  Monday?: InputMaybe<BooleanFilterInput>;
  Saturday?: InputMaybe<BooleanFilterInput>;
  Sunday?: InputMaybe<BooleanFilterInput>;
  Thursday?: InputMaybe<BooleanFilterInput>;
  Tuesday?: InputMaybe<BooleanFilterInput>;
  Wednesday?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentGeneralWeekdaysFiltersInput>>>;
  not?: InputMaybe<ComponentGeneralWeekdaysFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentGeneralWeekdaysFiltersInput>>>;
};

export type ComponentGeneralWeekdaysInput = {
  Friday?: InputMaybe<Scalars['Boolean']['input']>;
  Monday?: InputMaybe<Scalars['Boolean']['input']>;
  Saturday?: InputMaybe<Scalars['Boolean']['input']>;
  Sunday?: InputMaybe<Scalars['Boolean']['input']>;
  Thursday?: InputMaybe<Scalars['Boolean']['input']>;
  Tuesday?: InputMaybe<Scalars['Boolean']['input']>;
  Wednesday?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentGuidedToursGuidedTour = {
  __typename?: 'ComponentGuidedToursGuidedTour';
  description: Scalars['String']['output'];
  exhibition?: Maybe<Exhibition>;
  id: Scalars['ID']['output'];
  image: UploadFile;
  link?: Maybe<ComponentLinksLink>;
  order: Scalars['Int']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ComponentGuidedToursGuidedTourFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentGuidedToursGuidedTourFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  exhibition?: InputMaybe<ExhibitionFiltersInput>;
  link?: InputMaybe<ComponentLinksLinkFiltersInput>;
  not?: InputMaybe<ComponentGuidedToursGuidedTourFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentGuidedToursGuidedTourFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentGuidedToursGuidedTourInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  exhibition?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<ComponentLinksLinkInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentGuidedToursPostScript = {
  __typename?: 'ComponentGuidedToursPostScript';
  contactTimes?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentHeroHero = {
  __typename?: 'ComponentHeroHero';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: UploadFile;
  links?: Maybe<Array<Maybe<ComponentLinksLink>>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};


export type ComponentHeroHeroLinksArgs = {
  filters?: InputMaybe<ComponentLinksLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHeroHeroHome = {
  __typename?: 'ComponentHeroHeroHome';
  explore: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: UploadFile;
  welcome: Scalars['String']['output'];
};

export type ComponentHeroHeroHomeInput = {
  explore?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  welcome?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHeroHeroInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  links?: InputMaybe<Array<InputMaybe<ComponentLinksLinkInput>>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHomeTile = {
  __typename?: 'ComponentHomeTile';
  id: Scalars['ID']['output'];
  image: UploadFile;
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  route: ComponentLinksLink;
};

export type ComponentHomeTileFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHomeTileFiltersInput>>>;
  label?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentHomeTileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHomeTileFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  route?: InputMaybe<ComponentLinksLinkFiltersInput>;
};

export type ComponentHomeTileInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  route?: InputMaybe<ComponentLinksLinkInput>;
};

export type ComponentIntroHero = {
  __typename?: 'ComponentIntroHero';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: UploadFile;
  links?: Maybe<Array<Maybe<ComponentLinksLink>>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};


export type ComponentIntroHeroLinksArgs = {
  filters?: InputMaybe<ComponentLinksLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentIntroHeroInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  links?: InputMaybe<Array<InputMaybe<ComponentLinksLinkInput>>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentIntroSimple = {
  __typename?: 'ComponentIntroSimple';
  id: Scalars['ID']['output'];
  image: UploadFile;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ComponentIntroSimpleInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLinksLink = {
  __typename?: 'ComponentLinksLink';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: Enum_Componentlinkslink_Type;
  url: Scalars['String']['output'];
};

export type ComponentLinksLinkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLinksLinkFiltersInput>>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentLinksLinkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLinksLinkFiltersInput>>>;
  type?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentLinksLinkInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Componentlinkslink_Type>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLocationsEventLocation = {
  __typename?: 'ComponentLocationsEventLocation';
  address: ComponentContactAddress;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentLocationsLocation = {
  __typename?: 'ComponentLocationsLocation';
  id: Scalars['ID']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type ComponentLocationsLocationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLocationsLocationFiltersInput>>>;
  lat?: InputMaybe<FloatFilterInput>;
  lng?: InputMaybe<FloatFilterInput>;
  not?: InputMaybe<ComponentLocationsLocationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLocationsLocationFiltersInput>>>;
};

export type ComponentLocationsLocationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type ComponentPricingLocationPrice = {
  __typename?: 'ComponentPricingLocationPrice';
  id: Scalars['ID']['output'];
  priceTags: Array<Maybe<ComponentPricingPriceTag>>;
  timeRestrictions?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};


export type ComponentPricingLocationPricePriceTagsArgs = {
  filters?: InputMaybe<ComponentPricingPriceTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentPricingLocationPriceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentPricingLocationPriceFiltersInput>>>;
  not?: InputMaybe<ComponentPricingLocationPriceFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentPricingLocationPriceFiltersInput>>>;
  priceTags?: InputMaybe<ComponentPricingPriceTagFiltersInput>;
  timeRestrictions?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentPricingLocationPriceInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  priceTags?: InputMaybe<Array<InputMaybe<ComponentPricingPriceTagInput>>>;
  timeRestrictions?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentPricingPriceTag = {
  __typename?: 'ComponentPricingPriceTag';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  unit: Enum_Componentpricingpricetag_Unit;
};

export type ComponentPricingPriceTagFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentPricingPriceTagFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentPricingPriceTagFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentPricingPriceTagFiltersInput>>>;
  price?: InputMaybe<FloatFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  unit?: InputMaybe<StringFilterInput>;
};

export type ComponentPricingPriceTagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Enum_Componentpricingpricetag_Unit>;
};

export type ComponentSitePricingCategoryData = {
  __typename?: 'ComponentSitePricingCategoryData';
  id: Scalars['ID']['output'];
  image: UploadFile;
  links?: Maybe<Array<Maybe<ComponentLinksLink>>>;
  prices?: Maybe<Array<Maybe<ComponentPricingPriceTag>>>;
  title: Scalars['String']['output'];
};


export type ComponentSitePricingCategoryDataLinksArgs = {
  filters?: InputMaybe<ComponentLinksLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSitePricingCategoryDataPricesArgs = {
  filters?: InputMaybe<ComponentPricingPriceTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSitePricingCategoryDataFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSitePricingCategoryDataFiltersInput>>>;
  links?: InputMaybe<ComponentLinksLinkFiltersInput>;
  not?: InputMaybe<ComponentSitePricingCategoryDataFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSitePricingCategoryDataFiltersInput>>>;
  prices?: InputMaybe<ComponentPricingPriceTagFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSitePricingCategoryDataInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  links?: InputMaybe<Array<InputMaybe<ComponentLinksLinkInput>>>;
  prices?: InputMaybe<Array<InputMaybe<ComponentPricingPriceTagInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Contact = {
  __typename?: 'Contact';
  address: ComponentContactAddress;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  emailAddress: Scalars['String']['output'];
  hasChanges: Scalars['Boolean']['output'];
  phone: ComponentContactPhone;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  reachability?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContactInput = {
  address?: InputMaybe<ComponentContactAddressInput>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<ComponentContactPhoneInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reachability?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContactSlideOutContent = {
  __typename?: 'ContactSlideOutContent';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<ContactSlideOutContent>>;
  localizations_connection?: Maybe<ContactSlideOutContentRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  teamDescription: Scalars['String']['output'];
  teamTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContactSlideOutContentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  teamDescription?: InputMaybe<Scalars['String']['input']>;
  teamTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContactSlideOutContentRelationResponseCollection = {
  __typename?: 'ContactSlideOutContentRelationResponseCollection';
  nodes: Array<ContactSlideOutContent>;
};

export type ContentHome = {
  __typename?: 'ContentHome';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  hero: ComponentHeroHeroHome;
  intro?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<ContentHome>>;
  localizations_connection?: Maybe<ContentHomeRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  tiles: Array<Maybe<HomeTile>>;
  tiles_connection?: Maybe<HomeTileRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ContentHomeTilesArgs = {
  filters?: InputMaybe<HomeTileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ContentHomeTiles_ConnectionArgs = {
  filters?: InputMaybe<HomeTileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentHomeInput = {
  hero?: InputMaybe<ComponentHeroHeroHomeInput>;
  intro?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  tiles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ContentHomeRelationResponseCollection = {
  __typename?: 'ContentHomeRelationResponseCollection';
  nodes: Array<ContentHome>;
};

export type ContentOpeningHour = {
  __typename?: 'ContentOpeningHour';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  full: Scalars['String']['output'];
  hasChanges: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<ContentOpeningHour>>;
  localizations_connection?: Maybe<ContentOpeningHourRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  short: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContentOpeningHourInput = {
  full?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  short?: InputMaybe<Scalars['String']['input']>;
};

export type ContentOpeningHourRelationResponseCollection = {
  __typename?: 'ContentOpeningHourRelationResponseCollection';
  nodes: Array<ContentOpeningHour>;
};

export type DateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  contains?: InputMaybe<Scalars['Date']['input']>;
  containsi?: InputMaybe<Scalars['Date']['input']>;
  endsWith?: InputMaybe<Scalars['Date']['input']>;
  eq?: InputMaybe<Scalars['Date']['input']>;
  eqi?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nei?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<DateFilterInput>;
  notContains?: InputMaybe<Scalars['Date']['input']>;
  notContainsi?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  startsWith?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteMutationResponse = {
  __typename?: 'DeleteMutationResponse';
  documentId: Scalars['ID']['output'];
};

export enum Enum_Componentgeneraldetail_Viewvariant {
  Documents = 'DOCUMENTS',
  DocumentsMinimal = 'DOCUMENTS_MINIMAL',
  SplitContent = 'SPLIT_CONTENT'
}

export enum Enum_Componentgeneralprice_Currency {
  Eur = 'EUR'
}

export enum Enum_Componentlinkslink_Type {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export enum Enum_Componentpricingpricetag_Unit {
  Eur = 'EUR',
  Usd = 'USD'
}

export enum Enum_Entrancefee_Category {
  Basic = 'BASIC',
  Groups = 'GROUPS',
  GuidedTours = 'GUIDED_TOURS'
}

export enum Enum_Historyevent_Showdateas {
  DayAndYear = 'DAY_AND_YEAR',
  MonthAndYear = 'MONTH_AND_YEAR',
  YearOnly = 'YEAR_ONLY'
}

export enum Enum_Product_Category {
  Companion = 'COMPANION',
  Highlight = 'HIGHLIGHT',
  Other = 'OTHER',
  Publications = 'PUBLICATIONS'
}

export enum Enum_Relatedinfo_Viewvariant {
  Compact = 'COMPACT',
  Extensive = 'EXTENSIVE',
  Personal = 'PERSONAL'
}

export enum Enum_Shortguide_Lang {
  De = 'DE',
  En = 'EN',
  Fr = 'FR'
}

export enum Enum_Specialopeninghour_Type {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export enum Enum_Teammember_Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type EntranceFee = {
  __typename?: 'EntranceFee';
  category?: Maybe<Enum_Entrancefee_Category>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<EntranceFee>>;
  localizations_connection?: Maybe<EntranceFeeRelationResponseCollection>;
  price: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type EntranceFeeLocalizationsArgs = {
  filters?: InputMaybe<EntranceFeeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EntranceFeeLocalizations_ConnectionArgs = {
  filters?: InputMaybe<EntranceFeeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EntranceFeeEntityResponseCollection = {
  __typename?: 'EntranceFeeEntityResponseCollection';
  nodes: Array<EntranceFee>;
  pageInfo: Pagination;
};

export type EntranceFeeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EntranceFeeFiltersInput>>>;
  category?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<EntranceFeeFiltersInput>;
  not?: InputMaybe<EntranceFeeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EntranceFeeFiltersInput>>>;
  price?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EntranceFeeInput = {
  category?: InputMaybe<Enum_Entrancefee_Category>;
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EntranceFeeRelationResponseCollection = {
  __typename?: 'EntranceFeeRelationResponseCollection';
  nodes: Array<EntranceFee>;
};

export type Event = {
  __typename?: 'Event';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  endsAt: Scalars['DateTime']['output'];
  hasChanges: Scalars['Boolean']['output'];
  image?: Maybe<UploadFile>;
  images?: Maybe<Array<Maybe<ComponentGeneralOrdinalMedia>>>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<Event>>;
  localizations_connection?: Maybe<EventRelationResponseCollection>;
  prices?: Maybe<Array<Maybe<ComponentGeneralPrice>>>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  startsAt: Scalars['DateTime']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  venue?: Maybe<Venue>;
};


export type EventImagesArgs = {
  filters?: InputMaybe<ComponentGeneralOrdinalMediaFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EventLocalizationsArgs = {
  filters?: InputMaybe<EventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EventLocalizations_ConnectionArgs = {
  filters?: InputMaybe<EventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EventPricesArgs = {
  filters?: InputMaybe<ComponentGeneralPriceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EventEntityResponseCollection = {
  __typename?: 'EventEntityResponseCollection';
  nodes: Array<Event>;
  pageInfo: Pagination;
};

export type EventFiltersInput = {
  additionalInfo?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<EventFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  endsAt?: InputMaybe<DateTimeFilterInput>;
  images?: InputMaybe<ComponentGeneralOrdinalMediaFiltersInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<EventFiltersInput>;
  not?: InputMaybe<EventFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EventFiltersInput>>>;
  prices?: InputMaybe<ComponentGeneralPriceFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  startsAt?: InputMaybe<DateTimeFilterInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  venue?: InputMaybe<VenueFiltersInput>;
};

export type EventInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<InputMaybe<ComponentGeneralOrdinalMediaInput>>>;
  prices?: InputMaybe<Array<InputMaybe<ComponentGeneralPriceInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  venue?: InputMaybe<Scalars['ID']['input']>;
};

export type EventLocation = {
  __typename?: 'EventLocation';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  highlights?: Maybe<Array<Maybe<ComponentGeneralPictogram>>>;
  images: Array<Maybe<ComponentGeneralOrdinalMedia>>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<EventLocation>>;
  localizations_connection?: Maybe<EventLocationRelationResponseCollection>;
  order: Scalars['Int']['output'];
  prices?: Maybe<Array<Maybe<ComponentPricingLocationPrice>>>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type EventLocationHighlightsArgs = {
  filters?: InputMaybe<ComponentGeneralPictogramFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EventLocationImagesArgs = {
  filters?: InputMaybe<ComponentGeneralOrdinalMediaFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EventLocationLocalizationsArgs = {
  filters?: InputMaybe<EventLocationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EventLocationLocalizations_ConnectionArgs = {
  filters?: InputMaybe<EventLocationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EventLocationPricesArgs = {
  filters?: InputMaybe<ComponentPricingLocationPriceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EventLocationEntityResponseCollection = {
  __typename?: 'EventLocationEntityResponseCollection';
  nodes: Array<EventLocation>;
  pageInfo: Pagination;
};

export type EventLocationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EventLocationFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  highlights?: InputMaybe<ComponentGeneralPictogramFiltersInput>;
  images?: InputMaybe<ComponentGeneralOrdinalMediaFiltersInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<EventLocationFiltersInput>;
  not?: InputMaybe<EventLocationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EventLocationFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  prices?: InputMaybe<ComponentPricingLocationPriceFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EventLocationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  highlights?: InputMaybe<Array<InputMaybe<ComponentGeneralPictogramInput>>>;
  images?: InputMaybe<Array<InputMaybe<ComponentGeneralOrdinalMediaInput>>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  prices?: InputMaybe<Array<InputMaybe<ComponentPricingLocationPriceInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EventLocationRelationResponseCollection = {
  __typename?: 'EventLocationRelationResponseCollection';
  nodes: Array<EventLocation>;
};

export type EventRelationResponseCollection = {
  __typename?: 'EventRelationResponseCollection';
  nodes: Array<Event>;
};

export type Exhibition = {
  __typename?: 'Exhibition';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  details: Array<Maybe<ComponentGeneralDetail>>;
  documentId: Scalars['ID']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  excerpt: Scalars['String']['output'];
  flyerImage?: Maybe<UploadFile>;
  hasChanges: Scalars['Boolean']['output'];
  isHighlight: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<Exhibition>>;
  localizations_connection?: Maybe<ExhibitionRelationResponseCollection>;
  order: Scalars['Int']['output'];
  promoImage: UploadFile;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  relatedInfos: Array<Maybe<RelatedInfo>>;
  relatedInfos_connection?: Maybe<RelatedInfoRelationResponseCollection>;
  showroom?: Maybe<Showroom>;
  startDate?: Maybe<Scalars['Date']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ExhibitionDetailsArgs = {
  filters?: InputMaybe<ComponentGeneralDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ExhibitionLocalizationsArgs = {
  filters?: InputMaybe<ExhibitionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ExhibitionLocalizations_ConnectionArgs = {
  filters?: InputMaybe<ExhibitionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ExhibitionRelatedInfosArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ExhibitionRelatedInfos_ConnectionArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExhibitionEntityResponseCollection = {
  __typename?: 'ExhibitionEntityResponseCollection';
  nodes: Array<Exhibition>;
  pageInfo: Pagination;
};

export type ExhibitionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ExhibitionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  details?: InputMaybe<ComponentGeneralDetailFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  endDate?: InputMaybe<DateFilterInput>;
  excerpt?: InputMaybe<StringFilterInput>;
  isHighlight?: InputMaybe<BooleanFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ExhibitionFiltersInput>;
  not?: InputMaybe<ExhibitionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ExhibitionFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  relatedInfos?: InputMaybe<RelatedInfoFiltersInput>;
  showroom?: InputMaybe<ShowroomFiltersInput>;
  startDate?: InputMaybe<DateFilterInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ExhibitionInput = {
  details?: InputMaybe<Array<InputMaybe<ComponentGeneralDetailInput>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  flyerImage?: InputMaybe<Scalars['ID']['input']>;
  isHighlight?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  promoImage?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  relatedInfos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  showroom?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ExhibitionRelationResponseCollection = {
  __typename?: 'ExhibitionRelationResponseCollection';
  nodes: Array<Exhibition>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type FooterFlyer = {
  __typename?: 'FooterFlyer';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  flyer: UploadFile;
  hasChanges: Scalars['Boolean']['output'];
  preview?: Maybe<UploadFile>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FooterFlyerInput = {
  flyer?: InputMaybe<Scalars['ID']['input']>;
  preview?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GeneralOpeningHour = {
  __typename?: 'GeneralOpeningHour';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  endTime?: Maybe<Scalars['Time']['output']>;
  hasChanges: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<GeneralOpeningHour>>;
  localizations_connection?: Maybe<GeneralOpeningHourRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  startTime: Scalars['Time']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  weekdays: ComponentGeneralWeekdays;
};


export type GeneralOpeningHourLocalizationsArgs = {
  filters?: InputMaybe<GeneralOpeningHourFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type GeneralOpeningHourLocalizations_ConnectionArgs = {
  filters?: InputMaybe<GeneralOpeningHourFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GeneralOpeningHourEntityResponseCollection = {
  __typename?: 'GeneralOpeningHourEntityResponseCollection';
  nodes: Array<GeneralOpeningHour>;
  pageInfo: Pagination;
};

export type GeneralOpeningHourFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<GeneralOpeningHourFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  endTime?: InputMaybe<TimeFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<GeneralOpeningHourFiltersInput>;
  not?: InputMaybe<GeneralOpeningHourFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<GeneralOpeningHourFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  startTime?: InputMaybe<TimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  weekdays?: InputMaybe<ComponentGeneralWeekdaysFiltersInput>;
};

export type GeneralOpeningHourInput = {
  endTime?: InputMaybe<Scalars['Time']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
  weekdays?: InputMaybe<ComponentGeneralWeekdaysInput>;
};

export type GeneralOpeningHourRelationResponseCollection = {
  __typename?: 'GeneralOpeningHourRelationResponseCollection';
  nodes: Array<GeneralOpeningHour>;
};

export type GenericMorph = A11YStatement | Announcement | AuthenticPlace | AuthenticPlacesContent | ComponentA11Ya11YFeature | ComponentContactAddress | ComponentContactPhone | ComponentContactPhoneContact | ComponentGeneralDetail | ComponentGeneralOrdinalMedia | ComponentGeneralPictogram | ComponentGeneralPrice | ComponentGeneralShowpieces | ComponentGeneralWeekdays | ComponentGuidedToursGuidedTour | ComponentGuidedToursPostScript | ComponentHeroHero | ComponentHeroHeroHome | ComponentHomeTile | ComponentIntroHero | ComponentIntroSimple | ComponentLinksLink | ComponentLocationsEventLocation | ComponentLocationsLocation | ComponentPricingLocationPrice | ComponentPricingPriceTag | ComponentSitePricingCategoryData | Contact | ContactSlideOutContent | ContentHome | ContentOpeningHour | EntranceFee | Event | EventLocation | Exhibition | FooterFlyer | GeneralOpeningHour | GuidedTour | HistoryEvent | HomeTile | I18NLocale | Impressum | Partner | Privacy | Product | RelatedInfo | ResearchBlogEntry | ReviewWorkflowsWorkflow | ReviewWorkflowsWorkflowStage | RulesAndRegulationsGoverningUseAndFee | ShopContent | ShortGuide | Showroom | SiteAuthenticPlaces | SiteCityCuratorArchaeology | SiteCollection | SiteCooperation | SiteEducation | SiteEventLocation | SiteGuidedTour | SiteHistory | SiteHome | SitePhotoArchive | SitePricing | SiteResearch | SiteShop | SiteSpecialExhibition | SiteTeam | SlideOutA11Y | SlideOutContact | SlideOutEntranceFee | SlideOutEvent | SlideOutEventLocation | SlideOutNewsletter | SlideOutOpeningHour | SpecialOpeningHour | Tag | TeamMember | UploadFile | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser | Venue;

export type GuidedTour = {
  __typename?: 'GuidedTour';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  exhibition?: Maybe<Exhibition>;
  hasChanges: Scalars['Boolean']['output'];
  image: UploadFile;
  keyAspects: Scalars['String']['output'];
  link?: Maybe<ComponentLinksLink>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<GuidedTour>>;
  localizations_connection?: Maybe<GuidedTourRelationResponseCollection>;
  order: Scalars['Int']['output'];
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type GuidedTourLocalizationsArgs = {
  filters?: InputMaybe<GuidedTourFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type GuidedTourLocalizations_ConnectionArgs = {
  filters?: InputMaybe<GuidedTourFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GuidedTourEntityResponseCollection = {
  __typename?: 'GuidedTourEntityResponseCollection';
  nodes: Array<GuidedTour>;
  pageInfo: Pagination;
};

export type GuidedTourFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<GuidedTourFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  exhibition?: InputMaybe<ExhibitionFiltersInput>;
  keyAspects?: InputMaybe<StringFilterInput>;
  link?: InputMaybe<ComponentLinksLinkFiltersInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<GuidedTourFiltersInput>;
  not?: InputMaybe<GuidedTourFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<GuidedTourFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type GuidedTourInput = {
  exhibition?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  keyAspects?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<ComponentLinksLinkInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GuidedTourRelationResponseCollection = {
  __typename?: 'GuidedTourRelationResponseCollection';
  nodes: Array<GuidedTour>;
};

export type HistoryEvent = {
  __typename?: 'HistoryEvent';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  hasChanges: Scalars['Boolean']['output'];
  image?: Maybe<UploadFile>;
  links?: Maybe<Array<Maybe<ComponentLinksLink>>>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<HistoryEvent>>;
  localizations_connection?: Maybe<HistoryEventRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  readMore?: Maybe<UploadFile>;
  showDateAs: Enum_Historyevent_Showdateas;
  startDate: Scalars['Date']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type HistoryEventLinksArgs = {
  filters?: InputMaybe<ComponentLinksLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type HistoryEventLocalizationsArgs = {
  filters?: InputMaybe<HistoryEventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type HistoryEventLocalizations_ConnectionArgs = {
  filters?: InputMaybe<HistoryEventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HistoryEventEntityResponseCollection = {
  __typename?: 'HistoryEventEntityResponseCollection';
  nodes: Array<HistoryEvent>;
  pageInfo: Pagination;
};

export type HistoryEventFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<HistoryEventFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  endDate?: InputMaybe<DateFilterInput>;
  links?: InputMaybe<ComponentLinksLinkFiltersInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<HistoryEventFiltersInput>;
  not?: InputMaybe<HistoryEventFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<HistoryEventFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  showDateAs?: InputMaybe<StringFilterInput>;
  startDate?: InputMaybe<DateFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type HistoryEventInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  links?: InputMaybe<Array<InputMaybe<ComponentLinksLinkInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  readMore?: InputMaybe<Scalars['ID']['input']>;
  showDateAs?: InputMaybe<Enum_Historyevent_Showdateas>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HistoryEventRelationResponseCollection = {
  __typename?: 'HistoryEventRelationResponseCollection';
  nodes: Array<HistoryEvent>;
};

export type HomeTile = {
  __typename?: 'HomeTile';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  image: UploadFile;
  label: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<HomeTile>>;
  localizations_connection?: Maybe<HomeTileRelationResponseCollection>;
  order: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  route: ComponentLinksLink;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type HomeTileLocalizationsArgs = {
  filters?: InputMaybe<HomeTileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeTileLocalizations_ConnectionArgs = {
  filters?: InputMaybe<HomeTileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HomeTileEntityResponseCollection = {
  __typename?: 'HomeTileEntityResponseCollection';
  nodes: Array<HomeTile>;
  pageInfo: Pagination;
};

export type HomeTileFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<HomeTileFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<HomeTileFiltersInput>;
  not?: InputMaybe<HomeTileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<HomeTileFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  route?: InputMaybe<ComponentLinksLinkFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type HomeTileInput = {
  image?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  route?: InputMaybe<ComponentLinksLinkInput>;
};

export type HomeTileRelationResponseCollection = {
  __typename?: 'HomeTileRelationResponseCollection';
  nodes: Array<HomeTile>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  nodes: Array<I18NLocale>;
  pageInfo: Pagination;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type Impressum = {
  __typename?: 'Impressum';
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ImpressumInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createAuthenticPlace?: Maybe<AuthenticPlace>;
  createEntranceFee?: Maybe<EntranceFee>;
  createEvent?: Maybe<Event>;
  createEventLocation?: Maybe<EventLocation>;
  createExhibition?: Maybe<Exhibition>;
  createGeneralOpeningHour?: Maybe<GeneralOpeningHour>;
  createGuidedTour?: Maybe<GuidedTour>;
  createHistoryEvent?: Maybe<HistoryEvent>;
  createHomeTile?: Maybe<HomeTile>;
  createPartner?: Maybe<Partner>;
  createProduct?: Maybe<Product>;
  createRelatedInfo?: Maybe<RelatedInfo>;
  createResearchBlogEntry?: Maybe<ResearchBlogEntry>;
  createReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  createReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  createShortGuide?: Maybe<ShortGuide>;
  createShowroom?: Maybe<Showroom>;
  createSpecialOpeningHour?: Maybe<SpecialOpeningHour>;
  createTag?: Maybe<Tag>;
  createTeamMember?: Maybe<TeamMember>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  createVenue?: Maybe<Venue>;
  deleteA11YStatement?: Maybe<DeleteMutationResponse>;
  deleteAnnouncement?: Maybe<DeleteMutationResponse>;
  deleteAuthenticPlace?: Maybe<DeleteMutationResponse>;
  deleteAuthenticPlacesContent?: Maybe<DeleteMutationResponse>;
  deleteContact?: Maybe<DeleteMutationResponse>;
  deleteContactSlideOutContent?: Maybe<DeleteMutationResponse>;
  deleteContentHome?: Maybe<DeleteMutationResponse>;
  deleteContentOpeningHour?: Maybe<DeleteMutationResponse>;
  deleteEntranceFee?: Maybe<DeleteMutationResponse>;
  deleteEvent?: Maybe<DeleteMutationResponse>;
  deleteEventLocation?: Maybe<DeleteMutationResponse>;
  deleteExhibition?: Maybe<DeleteMutationResponse>;
  deleteFooterFlyer?: Maybe<DeleteMutationResponse>;
  deleteGeneralOpeningHour?: Maybe<DeleteMutationResponse>;
  deleteGuidedTour?: Maybe<DeleteMutationResponse>;
  deleteHistoryEvent?: Maybe<DeleteMutationResponse>;
  deleteHomeTile?: Maybe<DeleteMutationResponse>;
  deleteImpressum?: Maybe<DeleteMutationResponse>;
  deletePartner?: Maybe<DeleteMutationResponse>;
  deletePrivacy?: Maybe<DeleteMutationResponse>;
  deleteProduct?: Maybe<DeleteMutationResponse>;
  deleteRelatedInfo?: Maybe<DeleteMutationResponse>;
  deleteResearchBlogEntry?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflow?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflowStage?: Maybe<DeleteMutationResponse>;
  deleteRulesAndRegulationsGoverningUseAndFee?: Maybe<DeleteMutationResponse>;
  deleteShopContent?: Maybe<DeleteMutationResponse>;
  deleteShortGuide?: Maybe<DeleteMutationResponse>;
  deleteShowroom?: Maybe<DeleteMutationResponse>;
  deleteSiteAuthenticPlaces?: Maybe<DeleteMutationResponse>;
  deleteSiteCityCuratorArchaeology?: Maybe<DeleteMutationResponse>;
  deleteSiteCollection?: Maybe<DeleteMutationResponse>;
  deleteSiteCooperation?: Maybe<DeleteMutationResponse>;
  deleteSiteEducation?: Maybe<DeleteMutationResponse>;
  deleteSiteEventLocation?: Maybe<DeleteMutationResponse>;
  deleteSiteGuidedTour?: Maybe<DeleteMutationResponse>;
  deleteSiteHistory?: Maybe<DeleteMutationResponse>;
  deleteSiteHome?: Maybe<DeleteMutationResponse>;
  deleteSitePhotoArchive?: Maybe<DeleteMutationResponse>;
  deleteSitePricing?: Maybe<DeleteMutationResponse>;
  deleteSiteResearch?: Maybe<DeleteMutationResponse>;
  deleteSiteShop?: Maybe<DeleteMutationResponse>;
  deleteSiteSpecialExhibition?: Maybe<DeleteMutationResponse>;
  deleteSiteTeam?: Maybe<DeleteMutationResponse>;
  deleteSlideOutA11Y?: Maybe<DeleteMutationResponse>;
  deleteSlideOutContact?: Maybe<DeleteMutationResponse>;
  deleteSlideOutEntranceFee?: Maybe<DeleteMutationResponse>;
  deleteSlideOutEvent?: Maybe<DeleteMutationResponse>;
  deleteSlideOutEventLocation?: Maybe<DeleteMutationResponse>;
  deleteSlideOutNewsletter?: Maybe<DeleteMutationResponse>;
  deleteSlideOutOpeningHour?: Maybe<DeleteMutationResponse>;
  deleteSpecialOpeningHour?: Maybe<DeleteMutationResponse>;
  deleteTag?: Maybe<DeleteMutationResponse>;
  deleteTeamMember?: Maybe<DeleteMutationResponse>;
  deleteUploadFile?: Maybe<UploadFile>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteVenue?: Maybe<DeleteMutationResponse>;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  publishAnnouncement?: Maybe<Announcement>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  unpublishAnnouncement?: Maybe<Announcement>;
  updateA11YStatement?: Maybe<A11YStatement>;
  updateAnnouncement?: Maybe<Announcement>;
  updateAuthenticPlace?: Maybe<AuthenticPlace>;
  updateAuthenticPlacesContent?: Maybe<AuthenticPlacesContent>;
  updateContact?: Maybe<Contact>;
  updateContactSlideOutContent?: Maybe<ContactSlideOutContent>;
  updateContentHome?: Maybe<ContentHome>;
  updateContentOpeningHour?: Maybe<ContentOpeningHour>;
  updateEntranceFee?: Maybe<EntranceFee>;
  updateEvent?: Maybe<Event>;
  updateEventLocation?: Maybe<EventLocation>;
  updateExhibition?: Maybe<Exhibition>;
  updateFooterFlyer?: Maybe<FooterFlyer>;
  updateGeneralOpeningHour?: Maybe<GeneralOpeningHour>;
  updateGuidedTour?: Maybe<GuidedTour>;
  updateHistoryEvent?: Maybe<HistoryEvent>;
  updateHomeTile?: Maybe<HomeTile>;
  updateImpressum?: Maybe<Impressum>;
  updatePartner?: Maybe<Partner>;
  updatePrivacy?: Maybe<Privacy>;
  updateProduct?: Maybe<Product>;
  updateRelatedInfo?: Maybe<RelatedInfo>;
  updateResearchBlogEntry?: Maybe<ResearchBlogEntry>;
  updateReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  updateReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updateRulesAndRegulationsGoverningUseAndFee?: Maybe<RulesAndRegulationsGoverningUseAndFee>;
  updateShopContent?: Maybe<ShopContent>;
  updateShortGuide?: Maybe<ShortGuide>;
  updateShowroom?: Maybe<Showroom>;
  updateSiteAuthenticPlaces?: Maybe<SiteAuthenticPlaces>;
  updateSiteCityCuratorArchaeology?: Maybe<SiteCityCuratorArchaeology>;
  updateSiteCollection?: Maybe<SiteCollection>;
  updateSiteCooperation?: Maybe<SiteCooperation>;
  updateSiteEducation?: Maybe<SiteEducation>;
  updateSiteEventLocation?: Maybe<SiteEventLocation>;
  updateSiteGuidedTour?: Maybe<SiteGuidedTour>;
  updateSiteHistory?: Maybe<SiteHistory>;
  updateSiteHome?: Maybe<SiteHome>;
  updateSitePhotoArchive?: Maybe<SitePhotoArchive>;
  updateSitePricing?: Maybe<SitePricing>;
  updateSiteResearch?: Maybe<SiteResearch>;
  updateSiteShop?: Maybe<SiteShop>;
  updateSiteSpecialExhibition?: Maybe<SiteSpecialExhibition>;
  updateSiteTeam?: Maybe<SiteTeam>;
  updateSlideOutA11Y?: Maybe<SlideOutA11Y>;
  updateSlideOutContact?: Maybe<SlideOutContact>;
  updateSlideOutEntranceFee?: Maybe<SlideOutEntranceFee>;
  updateSlideOutEvent?: Maybe<SlideOutEvent>;
  updateSlideOutEventLocation?: Maybe<SlideOutEventLocation>;
  updateSlideOutNewsletter?: Maybe<SlideOutNewsletter>;
  updateSlideOutOpeningHour?: Maybe<SlideOutOpeningHour>;
  updateSpecialOpeningHour?: Maybe<SpecialOpeningHour>;
  updateTag?: Maybe<Tag>;
  updateTeamMember?: Maybe<TeamMember>;
  updateUploadFile: UploadFile;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  updateVenue?: Maybe<Venue>;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationCreateAuthenticPlaceArgs = {
  data: AuthenticPlaceInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateEntranceFeeArgs = {
  data: EntranceFeeInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateEventArgs = {
  data: EventInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateEventLocationArgs = {
  data: EventLocationInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateExhibitionArgs = {
  data: ExhibitionInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateGeneralOpeningHourArgs = {
  data: GeneralOpeningHourInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateGuidedTourArgs = {
  data: GuidedTourInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateHistoryEventArgs = {
  data: HistoryEventInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateHomeTileArgs = {
  data: HomeTileInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreatePartnerArgs = {
  data: PartnerInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateProductArgs = {
  data: ProductInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateRelatedInfoArgs = {
  data: RelatedInfoInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateResearchBlogEntryArgs = {
  data: ResearchBlogEntryInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateShortGuideArgs = {
  data: ShortGuideInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateShowroomArgs = {
  data: ShowroomInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateSpecialOpeningHourArgs = {
  data: SpecialOpeningHourInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateTagArgs = {
  data: TagInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateTeamMemberArgs = {
  data: TeamMemberInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationCreateVenueArgs = {
  data: VenueInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationDeleteAnnouncementArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteAuthenticPlaceArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteAuthenticPlacesContentArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteContactSlideOutContentArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteContentHomeArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteContentOpeningHourArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteEntranceFeeArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteEventArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteEventLocationArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteExhibitionArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteGeneralOpeningHourArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteGuidedTourArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteHistoryEventArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteHomeTileArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeletePartnerArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteProductArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteRelatedInfoArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteResearchBlogEntryArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteShopContentArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteShortGuideArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteShowroomArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteSiteAuthenticPlacesArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteSiteCityCuratorArchaeologyArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteSiteCollectionArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteSiteEducationArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteSiteEventLocationArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteSiteGuidedTourArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteSitePhotoArchiveArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteSiteResearchArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteSiteShopArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteSiteSpecialExhibitionArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteSlideOutEntranceFeeArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteSlideOutOpeningHourArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteSpecialOpeningHourArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteTagArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteTeamMemberArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVenueArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationPublishAnnouncementArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationUnpublishAnnouncementArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateA11YStatementArgs = {
  data: A11YStatementInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateAnnouncementArgs = {
  data: AnnouncementInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateAuthenticPlaceArgs = {
  data: AuthenticPlaceInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateAuthenticPlacesContentArgs = {
  data: AuthenticPlacesContentInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateContactArgs = {
  data: ContactInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateContactSlideOutContentArgs = {
  data: ContactSlideOutContentInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateContentHomeArgs = {
  data: ContentHomeInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateContentOpeningHourArgs = {
  data: ContentOpeningHourInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateEntranceFeeArgs = {
  data: EntranceFeeInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateEventArgs = {
  data: EventInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateEventLocationArgs = {
  data: EventLocationInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateExhibitionArgs = {
  data: ExhibitionInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateFooterFlyerArgs = {
  data: FooterFlyerInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateGeneralOpeningHourArgs = {
  data: GeneralOpeningHourInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateGuidedTourArgs = {
  data: GuidedTourInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateHistoryEventArgs = {
  data: HistoryEventInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateHomeTileArgs = {
  data: HomeTileInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateImpressumArgs = {
  data: ImpressumInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdatePartnerArgs = {
  data: PartnerInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdatePrivacyArgs = {
  data: PrivacyInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateProductArgs = {
  data: ProductInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateRelatedInfoArgs = {
  data: RelatedInfoInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateResearchBlogEntryArgs = {
  data: ResearchBlogEntryInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateRulesAndRegulationsGoverningUseAndFeeArgs = {
  data: RulesAndRegulationsGoverningUseAndFeeInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateShopContentArgs = {
  data: ShopContentInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateShortGuideArgs = {
  data: ShortGuideInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateShowroomArgs = {
  data: ShowroomInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSiteAuthenticPlacesArgs = {
  data: SiteAuthenticPlacesInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSiteCityCuratorArchaeologyArgs = {
  data: SiteCityCuratorArchaeologyInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSiteCollectionArgs = {
  data: SiteCollectionInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSiteCooperationArgs = {
  data: SiteCooperationInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSiteEducationArgs = {
  data: SiteEducationInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSiteEventLocationArgs = {
  data: SiteEventLocationInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSiteGuidedTourArgs = {
  data: SiteGuidedTourInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSiteHistoryArgs = {
  data: SiteHistoryInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSiteHomeArgs = {
  data: SiteHomeInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSitePhotoArchiveArgs = {
  data: SitePhotoArchiveInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSitePricingArgs = {
  data: SitePricingInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSiteResearchArgs = {
  data: SiteResearchInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSiteShopArgs = {
  data: SiteShopInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSiteSpecialExhibitionArgs = {
  data: SiteSpecialExhibitionInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSiteTeamArgs = {
  data: SiteTeamInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSlideOutA11YArgs = {
  data: SlideOutA11YInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSlideOutContactArgs = {
  data: SlideOutContactInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSlideOutEntranceFeeArgs = {
  data: SlideOutEntranceFeeInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSlideOutEventArgs = {
  data: SlideOutEventInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSlideOutEventLocationArgs = {
  data: SlideOutEventLocationInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSlideOutNewsletterArgs = {
  data: SlideOutNewsletterInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSlideOutOpeningHourArgs = {
  data: SlideOutOpeningHourInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSpecialOpeningHourArgs = {
  data: SpecialOpeningHourInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateTagArgs = {
  data: TagInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateTeamMemberArgs = {
  data: TeamMemberInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateUploadFileArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateVenueArgs = {
  data: VenueInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type Partner = {
  __typename?: 'Partner';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  hasChanges: Scalars['Boolean']['output'];
  image?: Maybe<UploadFile>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<ComponentContactPhone>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<ComponentLinksLink>;
};

export type PartnerEntityResponseCollection = {
  __typename?: 'PartnerEntityResponseCollection';
  nodes: Array<Partner>;
  pageInfo: Pagination;
};

export type PartnerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PartnerFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PartnerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PartnerFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  phone?: InputMaybe<ComponentContactPhoneFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  website?: InputMaybe<ComponentLinksLinkFiltersInput>;
};

export type PartnerInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<ComponentContactPhoneInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<ComponentLinksLinkInput>;
};

export type Privacy = {
  __typename?: 'Privacy';
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PrivacyInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Product = {
  __typename?: 'Product';
  category: Enum_Product_Category;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  image?: Maybe<UploadFile>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<Product>>;
  localizations_connection?: Maybe<ProductRelationResponseCollection>;
  price: Scalars['Float']['output'];
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ProductLocalizationsArgs = {
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProductLocalizations_ConnectionArgs = {
  filters?: InputMaybe<ProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProductEntityResponseCollection = {
  __typename?: 'ProductEntityResponseCollection';
  nodes: Array<Product>;
  pageInfo: Pagination;
};

export type ProductFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProductFiltersInput>>>;
  category?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ProductFiltersInput>;
  not?: InputMaybe<ProductFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProductFiltersInput>>>;
  price?: InputMaybe<FloatFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  rank?: InputMaybe<IntFilterInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProductInput = {
  category?: InputMaybe<Enum_Product_Category>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProductRelationResponseCollection = {
  __typename?: 'ProductRelationResponseCollection';
  nodes: Array<Product>;
};

export enum PublicationStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type Query = {
  __typename?: 'Query';
  a11YStatement?: Maybe<A11YStatement>;
  announcement?: Maybe<Announcement>;
  authenticPlace?: Maybe<AuthenticPlace>;
  authenticPlaces: Array<Maybe<AuthenticPlace>>;
  authenticPlacesContent?: Maybe<AuthenticPlacesContent>;
  authenticPlaces_connection?: Maybe<AuthenticPlaceEntityResponseCollection>;
  contact?: Maybe<Contact>;
  contactSlideOutContent?: Maybe<ContactSlideOutContent>;
  contentHome?: Maybe<ContentHome>;
  contentOpeningHour?: Maybe<ContentOpeningHour>;
  entranceFee?: Maybe<EntranceFee>;
  entranceFees: Array<Maybe<EntranceFee>>;
  entranceFees_connection?: Maybe<EntranceFeeEntityResponseCollection>;
  event?: Maybe<Event>;
  eventLocation?: Maybe<EventLocation>;
  eventLocations: Array<Maybe<EventLocation>>;
  eventLocations_connection?: Maybe<EventLocationEntityResponseCollection>;
  events: Array<Maybe<Event>>;
  events_connection?: Maybe<EventEntityResponseCollection>;
  exhibition?: Maybe<Exhibition>;
  exhibitions: Array<Maybe<Exhibition>>;
  exhibitions_connection?: Maybe<ExhibitionEntityResponseCollection>;
  footerFlyer?: Maybe<FooterFlyer>;
  generalOpeningHour?: Maybe<GeneralOpeningHour>;
  generalOpeningHours: Array<Maybe<GeneralOpeningHour>>;
  generalOpeningHours_connection?: Maybe<GeneralOpeningHourEntityResponseCollection>;
  guidedTour?: Maybe<GuidedTour>;
  guidedTours: Array<Maybe<GuidedTour>>;
  guidedTours_connection?: Maybe<GuidedTourEntityResponseCollection>;
  historyEvent?: Maybe<HistoryEvent>;
  historyEvents: Array<Maybe<HistoryEvent>>;
  historyEvents_connection?: Maybe<HistoryEventEntityResponseCollection>;
  homeTile?: Maybe<HomeTile>;
  homeTiles: Array<Maybe<HomeTile>>;
  homeTiles_connection?: Maybe<HomeTileEntityResponseCollection>;
  i18NLocale?: Maybe<I18NLocale>;
  i18NLocales: Array<Maybe<I18NLocale>>;
  i18NLocales_connection?: Maybe<I18NLocaleEntityResponseCollection>;
  impressum?: Maybe<Impressum>;
  me?: Maybe<UsersPermissionsMe>;
  partner?: Maybe<Partner>;
  partners: Array<Maybe<Partner>>;
  partners_connection?: Maybe<PartnerEntityResponseCollection>;
  privacy?: Maybe<Privacy>;
  product?: Maybe<Product>;
  products: Array<Maybe<Product>>;
  products_connection?: Maybe<ProductEntityResponseCollection>;
  relatedInfo?: Maybe<RelatedInfo>;
  relatedInfos: Array<Maybe<RelatedInfo>>;
  relatedInfos_connection?: Maybe<RelatedInfoEntityResponseCollection>;
  researchBlogEntries: Array<Maybe<ResearchBlogEntry>>;
  researchBlogEntries_connection?: Maybe<ResearchBlogEntryEntityResponseCollection>;
  researchBlogEntry?: Maybe<ResearchBlogEntry>;
  reviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  reviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  reviewWorkflowsWorkflowStages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  reviewWorkflowsWorkflowStages_connection?: Maybe<ReviewWorkflowsWorkflowStageEntityResponseCollection>;
  reviewWorkflowsWorkflows: Array<Maybe<ReviewWorkflowsWorkflow>>;
  reviewWorkflowsWorkflows_connection?: Maybe<ReviewWorkflowsWorkflowEntityResponseCollection>;
  rulesAndRegulationsGoverningUseAndFee?: Maybe<RulesAndRegulationsGoverningUseAndFee>;
  shopContent?: Maybe<ShopContent>;
  shortGuide?: Maybe<ShortGuide>;
  shortGuides: Array<Maybe<ShortGuide>>;
  shortGuides_connection?: Maybe<ShortGuideEntityResponseCollection>;
  showroom?: Maybe<Showroom>;
  showrooms: Array<Maybe<Showroom>>;
  showrooms_connection?: Maybe<ShowroomEntityResponseCollection>;
  siteAuthenticPlaces?: Maybe<SiteAuthenticPlaces>;
  siteCityCuratorArchaeology?: Maybe<SiteCityCuratorArchaeology>;
  siteCollection?: Maybe<SiteCollection>;
  siteCooperation?: Maybe<SiteCooperation>;
  siteEducation?: Maybe<SiteEducation>;
  siteEventLocation?: Maybe<SiteEventLocation>;
  siteGuidedTour?: Maybe<SiteGuidedTour>;
  siteHistory?: Maybe<SiteHistory>;
  siteHome?: Maybe<SiteHome>;
  sitePhotoArchive?: Maybe<SitePhotoArchive>;
  sitePricing?: Maybe<SitePricing>;
  siteResearch?: Maybe<SiteResearch>;
  siteShop?: Maybe<SiteShop>;
  siteSpecialExhibition?: Maybe<SiteSpecialExhibition>;
  siteTeam?: Maybe<SiteTeam>;
  slideOutA11Y?: Maybe<SlideOutA11Y>;
  slideOutContact?: Maybe<SlideOutContact>;
  slideOutEntranceFee?: Maybe<SlideOutEntranceFee>;
  slideOutEvent?: Maybe<SlideOutEvent>;
  slideOutEventLocation?: Maybe<SlideOutEventLocation>;
  slideOutNewsletter?: Maybe<SlideOutNewsletter>;
  slideOutOpeningHour?: Maybe<SlideOutOpeningHour>;
  specialOpeningHour?: Maybe<SpecialOpeningHour>;
  specialOpeningHours: Array<Maybe<SpecialOpeningHour>>;
  specialOpeningHours_connection?: Maybe<SpecialOpeningHourEntityResponseCollection>;
  tag?: Maybe<Tag>;
  tags: Array<Maybe<Tag>>;
  tags_connection?: Maybe<TagEntityResponseCollection>;
  teamMember?: Maybe<TeamMember>;
  teamMembers: Array<Maybe<TeamMember>>;
  teamMembers_connection?: Maybe<TeamMemberEntityResponseCollection>;
  uploadFile?: Maybe<UploadFile>;
  uploadFiles: Array<Maybe<UploadFile>>;
  uploadFiles_connection?: Maybe<UploadFileEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRole>;
  usersPermissionsRoles: Array<Maybe<UsersPermissionsRole>>;
  usersPermissionsRoles_connection?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUser>;
  usersPermissionsUsers: Array<Maybe<UsersPermissionsUser>>;
  usersPermissionsUsers_connection?: Maybe<UsersPermissionsUserEntityResponseCollection>;
  venue?: Maybe<Venue>;
  venues: Array<Maybe<Venue>>;
  venues_connection?: Maybe<VenueEntityResponseCollection>;
};


export type QueryA11YStatementArgs = {
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAnnouncementArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAuthenticPlaceArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAuthenticPlacesArgs = {
  filters?: InputMaybe<AuthenticPlaceFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAuthenticPlacesContentArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAuthenticPlaces_ConnectionArgs = {
  filters?: InputMaybe<AuthenticPlaceFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryContactArgs = {
  status?: InputMaybe<PublicationStatus>;
};


export type QueryContactSlideOutContentArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryContentHomeArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryContentOpeningHourArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryEntranceFeeArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryEntranceFeesArgs = {
  filters?: InputMaybe<EntranceFeeFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryEntranceFees_ConnectionArgs = {
  filters?: InputMaybe<EntranceFeeFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryEventArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryEventLocationArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryEventLocationsArgs = {
  filters?: InputMaybe<EventLocationFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryEventLocations_ConnectionArgs = {
  filters?: InputMaybe<EventLocationFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryEventsArgs = {
  filters?: InputMaybe<EventFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryEvents_ConnectionArgs = {
  filters?: InputMaybe<EventFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryExhibitionArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryExhibitionsArgs = {
  filters?: InputMaybe<ExhibitionFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryExhibitions_ConnectionArgs = {
  filters?: InputMaybe<ExhibitionFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryFooterFlyerArgs = {
  status?: InputMaybe<PublicationStatus>;
};


export type QueryGeneralOpeningHourArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryGeneralOpeningHoursArgs = {
  filters?: InputMaybe<GeneralOpeningHourFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryGeneralOpeningHours_ConnectionArgs = {
  filters?: InputMaybe<GeneralOpeningHourFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryGuidedTourArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryGuidedToursArgs = {
  filters?: InputMaybe<GuidedTourFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryGuidedTours_ConnectionArgs = {
  filters?: InputMaybe<GuidedTourFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryHistoryEventArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryHistoryEventsArgs = {
  filters?: InputMaybe<HistoryEventFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryHistoryEvents_ConnectionArgs = {
  filters?: InputMaybe<HistoryEventFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryHomeTileArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryHomeTilesArgs = {
  filters?: InputMaybe<HomeTileFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryHomeTiles_ConnectionArgs = {
  filters?: InputMaybe<HomeTileFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocaleArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocales_ConnectionArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryImpressumArgs = {
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPartnerArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPartnersArgs = {
  filters?: InputMaybe<PartnerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPartners_ConnectionArgs = {
  filters?: InputMaybe<PartnerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPrivacyArgs = {
  status?: InputMaybe<PublicationStatus>;
};


export type QueryProductArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryProductsArgs = {
  filters?: InputMaybe<ProductFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryProducts_ConnectionArgs = {
  filters?: InputMaybe<ProductFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryRelatedInfoArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryRelatedInfosArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryRelatedInfos_ConnectionArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryResearchBlogEntriesArgs = {
  filters?: InputMaybe<ResearchBlogEntryFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryResearchBlogEntries_ConnectionArgs = {
  filters?: InputMaybe<ResearchBlogEntryFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryResearchBlogEntryArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowsArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflows_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryRulesAndRegulationsGoverningUseAndFeeArgs = {
  status?: InputMaybe<PublicationStatus>;
};


export type QueryShopContentArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryShortGuideArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryShortGuidesArgs = {
  filters?: InputMaybe<ShortGuideFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryShortGuides_ConnectionArgs = {
  filters?: InputMaybe<ShortGuideFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryShowroomArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryShowroomsArgs = {
  filters?: InputMaybe<ShowroomFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryShowrooms_ConnectionArgs = {
  filters?: InputMaybe<ShowroomFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySiteAuthenticPlacesArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySiteCityCuratorArchaeologyArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySiteCollectionArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySiteCooperationArgs = {
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySiteEducationArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySiteEventLocationArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySiteGuidedTourArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySiteHistoryArgs = {
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySiteHomeArgs = {
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySitePhotoArchiveArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySitePricingArgs = {
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySiteResearchArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySiteShopArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySiteSpecialExhibitionArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySiteTeamArgs = {
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySlideOutA11YArgs = {
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySlideOutContactArgs = {
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySlideOutEntranceFeeArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySlideOutEventArgs = {
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySlideOutEventLocationArgs = {
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySlideOutNewsletterArgs = {
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySlideOutOpeningHourArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySpecialOpeningHourArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySpecialOpeningHoursArgs = {
  filters?: InputMaybe<SpecialOpeningHourFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySpecialOpeningHours_ConnectionArgs = {
  filters?: InputMaybe<SpecialOpeningHourFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryTagArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryTagsArgs = {
  filters?: InputMaybe<TagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryTags_ConnectionArgs = {
  filters?: InputMaybe<TagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryTeamMemberArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryTeamMembersArgs = {
  filters?: InputMaybe<TeamMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryTeamMembers_ConnectionArgs = {
  filters?: InputMaybe<TeamMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFileArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFiles_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRoleArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRoles_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsUserArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryVenueArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryVenuesArgs = {
  filters?: InputMaybe<VenueFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryVenues_ConnectionArgs = {
  filters?: InputMaybe<VenueFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type RelatedInfo = {
  __typename?: 'RelatedInfo';
  colSpan?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  image?: Maybe<UploadFile>;
  imagePosition?: Maybe<Scalars['String']['output']>;
  imageScale?: Maybe<Scalars['Float']['output']>;
  links?: Maybe<Array<Maybe<ComponentLinksLink>>>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<RelatedInfo>>;
  localizations_connection?: Maybe<RelatedInfoRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  showDivider: Scalars['Boolean']['output'];
  showGeneralContact: Scalars['Boolean']['output'];
  showLinksTitle: Scalars['Boolean']['output'];
  sideImage?: Maybe<UploadFile>;
  subtitle?: Maybe<Scalars['String']['output']>;
  teamMember?: Maybe<TeamMember>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  viewVariant: Enum_Relatedinfo_Viewvariant;
};


export type RelatedInfoLinksArgs = {
  filters?: InputMaybe<ComponentLinksLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RelatedInfoLocalizationsArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RelatedInfoLocalizations_ConnectionArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RelatedInfoEntityResponseCollection = {
  __typename?: 'RelatedInfoEntityResponseCollection';
  nodes: Array<RelatedInfo>;
  pageInfo: Pagination;
};

export type RelatedInfoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<RelatedInfoFiltersInput>>>;
  colSpan?: InputMaybe<IntFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  imagePosition?: InputMaybe<StringFilterInput>;
  imageScale?: InputMaybe<FloatFilterInput>;
  links?: InputMaybe<ComponentLinksLinkFiltersInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<RelatedInfoFiltersInput>;
  not?: InputMaybe<RelatedInfoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<RelatedInfoFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  showDivider?: InputMaybe<BooleanFilterInput>;
  showGeneralContact?: InputMaybe<BooleanFilterInput>;
  showLinksTitle?: InputMaybe<BooleanFilterInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  teamMember?: InputMaybe<TeamMemberFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  viewVariant?: InputMaybe<StringFilterInput>;
};

export type RelatedInfoInput = {
  colSpan?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  imagePosition?: InputMaybe<Scalars['String']['input']>;
  imageScale?: InputMaybe<Scalars['Float']['input']>;
  links?: InputMaybe<Array<InputMaybe<ComponentLinksLinkInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  showDivider?: InputMaybe<Scalars['Boolean']['input']>;
  showGeneralContact?: InputMaybe<Scalars['Boolean']['input']>;
  showLinksTitle?: InputMaybe<Scalars['Boolean']['input']>;
  sideImage?: InputMaybe<Scalars['ID']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  teamMember?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  viewVariant?: InputMaybe<Enum_Relatedinfo_Viewvariant>;
};

export type RelatedInfoRelationResponseCollection = {
  __typename?: 'RelatedInfoRelationResponseCollection';
  nodes: Array<RelatedInfo>;
};

export type ResearchBlogEntry = {
  __typename?: 'ResearchBlogEntry';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  details: Array<Maybe<ComponentGeneralDetail>>;
  documentId: Scalars['ID']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  hasChanges: Scalars['Boolean']['output'];
  image: UploadFile;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<ResearchBlogEntry>>;
  localizations_connection?: Maybe<ResearchBlogEntryRelationResponseCollection>;
  publications?: Maybe<Scalars['String']['output']>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ResearchBlogEntryDetailsArgs = {
  filters?: InputMaybe<ComponentGeneralDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ResearchBlogEntryLocalizationsArgs = {
  filters?: InputMaybe<ResearchBlogEntryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ResearchBlogEntryLocalizations_ConnectionArgs = {
  filters?: InputMaybe<ResearchBlogEntryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ResearchBlogEntryEntityResponseCollection = {
  __typename?: 'ResearchBlogEntryEntityResponseCollection';
  nodes: Array<ResearchBlogEntry>;
  pageInfo: Pagination;
};

export type ResearchBlogEntryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ResearchBlogEntryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  details?: InputMaybe<ComponentGeneralDetailFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  excerpt?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ResearchBlogEntryFiltersInput>;
  not?: InputMaybe<ResearchBlogEntryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ResearchBlogEntryFiltersInput>>>;
  publications?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ResearchBlogEntryInput = {
  details?: InputMaybe<Array<InputMaybe<ComponentGeneralDetailInput>>>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  publications?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ResearchBlogEntryRelationResponseCollection = {
  __typename?: 'ResearchBlogEntryRelationResponseCollection';
  nodes: Array<ResearchBlogEntry>;
};

export type ReviewWorkflowsWorkflow = {
  __typename?: 'ReviewWorkflowsWorkflow';
  contentTypes: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  stageRequiredToPublish?: Maybe<ReviewWorkflowsWorkflowStage>;
  stages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  stages_connection?: Maybe<ReviewWorkflowsWorkflowStageRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReviewWorkflowsWorkflowEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflow>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  contentTypes?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  stageRequiredToPublish?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  stages?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ReviewWorkflowsWorkflowInput = {
  contentTypes?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  stageRequiredToPublish?: InputMaybe<Scalars['ID']['input']>;
  stages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ReviewWorkflowsWorkflowStage = {
  __typename?: 'ReviewWorkflowsWorkflowStage';
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workflow?: Maybe<ReviewWorkflowsWorkflow>;
};

export type ReviewWorkflowsWorkflowStageEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowStageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  workflow?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
};

export type ReviewWorkflowsWorkflowStageInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workflow?: InputMaybe<Scalars['ID']['input']>;
};

export type ReviewWorkflowsWorkflowStageRelationResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageRelationResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
};

export type RulesAndRegulationsGoverningUseAndFee = {
  __typename?: 'RulesAndRegulationsGoverningUseAndFee';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  file: UploadFile;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RulesAndRegulationsGoverningUseAndFeeInput = {
  file?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ShopContent = {
  __typename?: 'ShopContent';
  companion: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  hero: ComponentHeroHero;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<ShopContent>>;
  localizations_connection?: Maybe<ShopContentRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ShopContentInput = {
  companion?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<ComponentHeroHeroInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ShopContentRelationResponseCollection = {
  __typename?: 'ShopContentRelationResponseCollection';
  nodes: Array<ShopContent>;
};

export type ShortGuide = {
  __typename?: 'ShortGuide';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  guide: UploadFile;
  hasChanges: Scalars['Boolean']['output'];
  lang: Enum_Shortguide_Lang;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ShortGuideEntityResponseCollection = {
  __typename?: 'ShortGuideEntityResponseCollection';
  nodes: Array<ShortGuide>;
  pageInfo: Pagination;
};

export type ShortGuideFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ShortGuideFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  lang?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ShortGuideFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ShortGuideFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ShortGuideInput = {
  guide?: InputMaybe<Scalars['ID']['input']>;
  lang?: InputMaybe<Enum_Shortguide_Lang>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Showroom = {
  __typename?: 'Showroom';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  images: Array<Maybe<UploadFile>>;
  images_connection: UploadFileRelationResponseCollection;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<Showroom>>;
  localizations_connection?: Maybe<ShowroomRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ShowroomImagesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ShowroomImages_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ShowroomLocalizationsArgs = {
  filters?: InputMaybe<ShowroomFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ShowroomLocalizations_ConnectionArgs = {
  filters?: InputMaybe<ShowroomFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ShowroomEntityResponseCollection = {
  __typename?: 'ShowroomEntityResponseCollection';
  nodes: Array<Showroom>;
  pageInfo: Pagination;
};

export type ShowroomFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ShowroomFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ShowroomFiltersInput>;
  not?: InputMaybe<ShowroomFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ShowroomFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ShowroomInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ShowroomRelationResponseCollection = {
  __typename?: 'ShowroomRelationResponseCollection';
  nodes: Array<Showroom>;
};

export type SiteAuthenticPlaces = {
  __typename?: 'SiteAuthenticPlaces';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  intro: ComponentIntroHero;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<SiteAuthenticPlaces>>;
  localizations_connection?: Maybe<SiteAuthenticPlacesRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SiteAuthenticPlacesInput = {
  intro?: InputMaybe<ComponentIntroHeroInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SiteAuthenticPlacesRelationResponseCollection = {
  __typename?: 'SiteAuthenticPlacesRelationResponseCollection';
  nodes: Array<SiteAuthenticPlaces>;
};

export type SiteCityCuratorArchaeology = {
  __typename?: 'SiteCityCuratorArchaeology';
  additionalIntroImages: Array<Maybe<UploadFile>>;
  additionalIntroImages_connection?: Maybe<UploadFileRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  details: Array<Maybe<ComponentGeneralDetail>>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<SiteCityCuratorArchaeology>>;
  localizations_connection?: Maybe<SiteCityCuratorArchaeologyRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  relatedInfos: Array<Maybe<RelatedInfo>>;
  relatedInfos_connection?: Maybe<RelatedInfoRelationResponseCollection>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SiteCityCuratorArchaeologyAdditionalIntroImagesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SiteCityCuratorArchaeologyAdditionalIntroImages_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SiteCityCuratorArchaeologyDetailsArgs = {
  filters?: InputMaybe<ComponentGeneralDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SiteCityCuratorArchaeologyRelatedInfosArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SiteCityCuratorArchaeologyRelatedInfos_ConnectionArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SiteCityCuratorArchaeologyInput = {
  additionalIntroImages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  details?: InputMaybe<Array<InputMaybe<ComponentGeneralDetailInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  relatedInfos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SiteCityCuratorArchaeologyRelationResponseCollection = {
  __typename?: 'SiteCityCuratorArchaeologyRelationResponseCollection';
  nodes: Array<SiteCityCuratorArchaeology>;
};

export type SiteCollection = {
  __typename?: 'SiteCollection';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  details: Array<Maybe<ComponentGeneralDetail>>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<SiteCollection>>;
  localizations_connection?: Maybe<SiteCollectionRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  relatedInfos: Array<Maybe<RelatedInfo>>;
  relatedInfos_connection?: Maybe<RelatedInfoRelationResponseCollection>;
  showroom?: Maybe<Showroom>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SiteCollectionDetailsArgs = {
  filters?: InputMaybe<ComponentGeneralDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SiteCollectionRelatedInfosArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SiteCollectionRelatedInfos_ConnectionArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SiteCollectionInput = {
  details?: InputMaybe<Array<InputMaybe<ComponentGeneralDetailInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  relatedInfos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  showroom?: InputMaybe<Scalars['ID']['input']>;
};

export type SiteCollectionRelationResponseCollection = {
  __typename?: 'SiteCollectionRelationResponseCollection';
  nodes: Array<SiteCollection>;
};

export type SiteCooperation = {
  __typename?: 'SiteCooperation';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  intro: ComponentIntroSimple;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SiteCooperationInput = {
  intro?: InputMaybe<ComponentIntroSimpleInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SiteEducation = {
  __typename?: 'SiteEducation';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  details: Array<Maybe<ComponentGeneralDetail>>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<SiteEducation>>;
  localizations_connection?: Maybe<SiteEducationRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  relatedInfos: Array<Maybe<RelatedInfo>>;
  relatedInfos_connection?: Maybe<RelatedInfoRelationResponseCollection>;
  showroom?: Maybe<Showroom>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SiteEducationDetailsArgs = {
  filters?: InputMaybe<ComponentGeneralDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SiteEducationRelatedInfosArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SiteEducationRelatedInfos_ConnectionArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SiteEducationInput = {
  details?: InputMaybe<Array<InputMaybe<ComponentGeneralDetailInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  relatedInfos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  showroom?: InputMaybe<Scalars['ID']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SiteEducationRelationResponseCollection = {
  __typename?: 'SiteEducationRelationResponseCollection';
  nodes: Array<SiteEducation>;
};

export type SiteEventLocation = {
  __typename?: 'SiteEventLocation';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  intro: ComponentIntroHero;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<SiteEventLocation>>;
  localizations_connection?: Maybe<SiteEventLocationRelationResponseCollection>;
  pricingImage?: Maybe<UploadFile>;
  pricingPostscript?: Maybe<Scalars['String']['output']>;
  pricingTitle?: Maybe<Scalars['String']['output']>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SiteEventLocationInput = {
  intro?: InputMaybe<ComponentIntroHeroInput>;
  pricingImage?: InputMaybe<Scalars['ID']['input']>;
  pricingPostscript?: InputMaybe<Scalars['String']['input']>;
  pricingTitle?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SiteEventLocationRelationResponseCollection = {
  __typename?: 'SiteEventLocationRelationResponseCollection';
  nodes: Array<SiteEventLocation>;
};

export type SiteGuidedTour = {
  __typename?: 'SiteGuidedTour';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  intro: ComponentIntroHero;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<SiteGuidedTour>>;
  localizations_connection?: Maybe<SiteGuidedTourRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  relatedInfos: Array<Maybe<RelatedInfo>>;
  relatedInfos_connection?: Maybe<RelatedInfoRelationResponseCollection>;
  tours: Array<Maybe<ComponentGuidedToursGuidedTour>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SiteGuidedTourRelatedInfosArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SiteGuidedTourRelatedInfos_ConnectionArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SiteGuidedTourToursArgs = {
  filters?: InputMaybe<ComponentGuidedToursGuidedTourFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SiteGuidedTourInput = {
  intro?: InputMaybe<ComponentIntroHeroInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  relatedInfos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  tours?: InputMaybe<Array<InputMaybe<ComponentGuidedToursGuidedTourInput>>>;
};

export type SiteGuidedTourRelationResponseCollection = {
  __typename?: 'SiteGuidedTourRelationResponseCollection';
  nodes: Array<SiteGuidedTour>;
};

export type SiteHistory = {
  __typename?: 'SiteHistory';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  intro: ComponentIntroSimple;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  showpieces: ComponentGeneralShowpieces;
  showroom?: Maybe<Showroom>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SiteHistoryInput = {
  intro?: InputMaybe<ComponentIntroSimpleInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  showpieces?: InputMaybe<ComponentGeneralShowpiecesInput>;
  showroom?: InputMaybe<Scalars['ID']['input']>;
};

export type SiteHome = {
  __typename?: 'SiteHome';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  image: UploadFile;
  intro?: Maybe<Scalars['String']['output']>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  tiles: Array<Maybe<ComponentHomeTile>>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SiteHomeTilesArgs = {
  filters?: InputMaybe<ComponentHomeTileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SiteHomeInput = {
  image?: InputMaybe<Scalars['ID']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  tiles?: InputMaybe<Array<InputMaybe<ComponentHomeTileInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SitePhotoArchive = {
  __typename?: 'SitePhotoArchive';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  details: Array<Maybe<ComponentGeneralDetail>>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<SitePhotoArchive>>;
  localizations_connection?: Maybe<SitePhotoArchiveRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  relatedInfos: Array<Maybe<RelatedInfo>>;
  relatedInfos_connection?: Maybe<RelatedInfoRelationResponseCollection>;
  showroom?: Maybe<Showroom>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SitePhotoArchiveDetailsArgs = {
  filters?: InputMaybe<ComponentGeneralDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SitePhotoArchiveRelatedInfosArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SitePhotoArchiveRelatedInfos_ConnectionArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SitePhotoArchiveInput = {
  details?: InputMaybe<Array<InputMaybe<ComponentGeneralDetailInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  relatedInfos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  showroom?: InputMaybe<Scalars['ID']['input']>;
};

export type SitePhotoArchiveRelationResponseCollection = {
  __typename?: 'SitePhotoArchiveRelationResponseCollection';
  nodes: Array<SitePhotoArchive>;
};

export type SitePricing = {
  __typename?: 'SitePricing';
  categories: Array<Maybe<ComponentSitePricingCategoryData>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  intro: ComponentIntroSimple;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  relatedInfos: Array<Maybe<RelatedInfo>>;
  relatedInfos_connection?: Maybe<RelatedInfoRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SitePricingCategoriesArgs = {
  filters?: InputMaybe<ComponentSitePricingCategoryDataFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SitePricingRelatedInfosArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SitePricingRelatedInfos_ConnectionArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SitePricingInput = {
  categories?: InputMaybe<Array<InputMaybe<ComponentSitePricingCategoryDataInput>>>;
  intro?: InputMaybe<ComponentIntroSimpleInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  relatedInfos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type SiteResearch = {
  __typename?: 'SiteResearch';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  intro: ComponentIntroHero;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<SiteResearch>>;
  localizations_connection?: Maybe<SiteResearchRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SiteResearchInput = {
  intro?: InputMaybe<ComponentIntroHeroInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SiteResearchRelationResponseCollection = {
  __typename?: 'SiteResearchRelationResponseCollection';
  nodes: Array<SiteResearch>;
};

export type SiteShop = {
  __typename?: 'SiteShop';
  companion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  intro: ComponentIntroHero;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<SiteShop>>;
  localizations_connection?: Maybe<SiteShopRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  relatedInfos: Array<Maybe<RelatedInfo>>;
  relatedInfos_connection?: Maybe<RelatedInfoRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SiteShopRelatedInfosArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SiteShopRelatedInfos_ConnectionArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SiteShopInput = {
  companion?: InputMaybe<Scalars['String']['input']>;
  intro?: InputMaybe<ComponentIntroHeroInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  relatedInfos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type SiteShopRelationResponseCollection = {
  __typename?: 'SiteShopRelationResponseCollection';
  nodes: Array<SiteShop>;
};

export type SiteSpecialExhibition = {
  __typename?: 'SiteSpecialExhibition';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  intro: ComponentIntroSimple;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<SiteSpecialExhibition>>;
  localizations_connection?: Maybe<SiteSpecialExhibitionRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  relatedInfos: Array<Maybe<RelatedInfo>>;
  relatedInfos_connection?: Maybe<RelatedInfoRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SiteSpecialExhibitionRelatedInfosArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SiteSpecialExhibitionRelatedInfos_ConnectionArgs = {
  filters?: InputMaybe<RelatedInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SiteSpecialExhibitionInput = {
  intro?: InputMaybe<ComponentIntroSimpleInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  relatedInfos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type SiteSpecialExhibitionRelationResponseCollection = {
  __typename?: 'SiteSpecialExhibitionRelationResponseCollection';
  nodes: Array<SiteSpecialExhibition>;
};

export type SiteTeam = {
  __typename?: 'SiteTeam';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  intro: ComponentIntroSimple;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SiteTeamInput = {
  intro?: InputMaybe<ComponentIntroSimpleInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SlideOutA11Y = {
  __typename?: 'SlideOutA11Y';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  features: Array<Maybe<ComponentA11Ya11YFeature>>;
  hasChanges: Scalars['Boolean']['output'];
  image: UploadFile;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SlideOutA11YFeaturesArgs = {
  filters?: InputMaybe<ComponentA11Ya11YFeatureFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SlideOutA11YInput = {
  features?: InputMaybe<Array<InputMaybe<ComponentA11Ya11YFeatureInput>>>;
  image?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SlideOutContact = {
  __typename?: 'SlideOutContact';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  image: UploadFile;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  teamDescription: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SlideOutContactInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  teamDescription?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SlideOutEntranceFee = {
  __typename?: 'SlideOutEntranceFee';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  discounted?: Maybe<EntranceFee>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  image: UploadFile;
  links: Array<Maybe<ComponentLinksLink>>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<SlideOutEntranceFee>>;
  localizations_connection?: Maybe<SlideOutEntranceFeeRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  regular?: Maybe<EntranceFee>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SlideOutEntranceFeeLinksArgs = {
  filters?: InputMaybe<ComponentLinksLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SlideOutEntranceFeeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discounted?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  links?: InputMaybe<Array<InputMaybe<ComponentLinksLinkInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  regular?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SlideOutEntranceFeeRelationResponseCollection = {
  __typename?: 'SlideOutEntranceFeeRelationResponseCollection';
  nodes: Array<SlideOutEntranceFee>;
};

export type SlideOutEvent = {
  __typename?: 'SlideOutEvent';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  image: UploadFile;
  links: Array<Maybe<ComponentLinksLink>>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SlideOutEventLinksArgs = {
  filters?: InputMaybe<ComponentLinksLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SlideOutEventInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  links?: InputMaybe<Array<InputMaybe<ComponentLinksLinkInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SlideOutEventLocation = {
  __typename?: 'SlideOutEventLocation';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  image: UploadFile;
  links?: Maybe<Array<Maybe<ComponentLinksLink>>>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SlideOutEventLocationLinksArgs = {
  filters?: InputMaybe<ComponentLinksLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SlideOutEventLocationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  links?: InputMaybe<Array<InputMaybe<ComponentLinksLinkInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SlideOutNewsletter = {
  __typename?: 'SlideOutNewsletter';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  image: UploadFile;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SlideOutNewsletterInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SlideOutOpeningHour = {
  __typename?: 'SlideOutOpeningHour';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  image: UploadFile;
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<SlideOutOpeningHour>>;
  localizations_connection?: Maybe<SlideOutOpeningHourRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SlideOutOpeningHourInput = {
  image?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SlideOutOpeningHourRelationResponseCollection = {
  __typename?: 'SlideOutOpeningHourRelationResponseCollection';
  nodes: Array<SlideOutOpeningHour>;
};

export type SpecialOpeningHour = {
  __typename?: 'SpecialOpeningHour';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  hasChanges: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<SpecialOpeningHour>>;
  localizations_connection?: Maybe<SpecialOpeningHourRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  recurrenceRule?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['Date']['output'];
  title: Scalars['String']['output'];
  type: Enum_Specialopeninghour_Type;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SpecialOpeningHourLocalizationsArgs = {
  filters?: InputMaybe<SpecialOpeningHourFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SpecialOpeningHourLocalizations_ConnectionArgs = {
  filters?: InputMaybe<SpecialOpeningHourFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SpecialOpeningHourEntityResponseCollection = {
  __typename?: 'SpecialOpeningHourEntityResponseCollection';
  nodes: Array<SpecialOpeningHour>;
  pageInfo: Pagination;
};

export type SpecialOpeningHourFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SpecialOpeningHourFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  endDate?: InputMaybe<DateFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<SpecialOpeningHourFiltersInput>;
  not?: InputMaybe<SpecialOpeningHourFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SpecialOpeningHourFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  recurrenceRule?: InputMaybe<StringFilterInput>;
  startDate?: InputMaybe<DateFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SpecialOpeningHourInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  recurrenceRule?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Specialopeninghour_Type>;
};

export type SpecialOpeningHourRelationResponseCollection = {
  __typename?: 'SpecialOpeningHourRelationResponseCollection';
  nodes: Array<SpecialOpeningHour>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Tag = {
  __typename?: 'Tag';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  files: Array<Maybe<UploadFile>>;
  files_connection?: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TagFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TagFiles_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TagEntityResponseCollection = {
  __typename?: 'TagEntityResponseCollection';
  nodes: Array<Tag>;
  pageInfo: Pagination;
};

export type TagFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TagFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<TagFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TagFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type TagInput = {
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamMember = {
  __typename?: 'TeamMember';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender: Enum_Teammember_Gender;
  hasChanges: Scalars['Boolean']['output'];
  image?: Maybe<UploadFile>;
  lastName: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  phones: Array<Maybe<ComponentContactPhone>>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TeamMemberPhonesArgs = {
  filters?: InputMaybe<ComponentContactPhoneFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TeamMemberEntityResponseCollection = {
  __typename?: 'TeamMemberEntityResponseCollection';
  nodes: Array<TeamMember>;
  pageInfo: Pagination;
};

export type TeamMemberFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TeamMemberFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  firstName?: InputMaybe<StringFilterInput>;
  gender?: InputMaybe<StringFilterInput>;
  lastName?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<TeamMemberFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TeamMemberFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  phones?: InputMaybe<ComponentContactPhoneFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type TeamMemberInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Enum_Teammember_Gender>;
  image?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  phones?: InputMaybe<Array<InputMaybe<ComponentContactPhoneInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Time']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Time']['input']>>>;
  contains?: InputMaybe<Scalars['Time']['input']>;
  containsi?: InputMaybe<Scalars['Time']['input']>;
  endsWith?: InputMaybe<Scalars['Time']['input']>;
  eq?: InputMaybe<Scalars['Time']['input']>;
  eqi?: InputMaybe<Scalars['Time']['input']>;
  gt?: InputMaybe<Scalars['Time']['input']>;
  gte?: InputMaybe<Scalars['Time']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Time']['input']>>>;
  lt?: InputMaybe<Scalars['Time']['input']>;
  lte?: InputMaybe<Scalars['Time']['input']>;
  ne?: InputMaybe<Scalars['Time']['input']>;
  nei?: InputMaybe<Scalars['Time']['input']>;
  not?: InputMaybe<TimeFilterInput>;
  notContains?: InputMaybe<Scalars['Time']['input']>;
  notContainsi?: InputMaybe<Scalars['Time']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Time']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Time']['input']>>>;
  startsWith?: InputMaybe<Scalars['Time']['input']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  referenceCount: Scalars['Int']['output'];
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  tags?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  nodes: Array<UploadFile>;
  pageInfo: Pagination;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  tags?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  nodes: Array<UploadFile>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  documentId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  nodes: Array<UsersPermissionsPermission>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Maybe<UsersPermissionsPermission>>;
  permissions_connection?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<Maybe<UsersPermissionsUser>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRolePermissions_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  nodes: Array<UsersPermissionsRole>;
  pageInfo: Pagination;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUser>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  nodes: Array<UsersPermissionsUser>;
  pageInfo: Pagination;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  provider?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  nodes: Array<UsersPermissionsUser>;
};

export type Venue = {
  __typename?: 'Venue';
  address?: Maybe<ComponentContactAddress>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  hasChanges: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<Venue>>;
  localizations_connection?: Maybe<VenueRelationResponseCollection>;
  published: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type VenueLocalizationsArgs = {
  filters?: InputMaybe<VenueFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type VenueLocalizations_ConnectionArgs = {
  filters?: InputMaybe<VenueFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VenueEntityResponseCollection = {
  __typename?: 'VenueEntityResponseCollection';
  nodes: Array<Venue>;
  pageInfo: Pagination;
};

export type VenueFiltersInput = {
  address?: InputMaybe<ComponentContactAddressFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<VenueFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<VenueFiltersInput>;
  not?: InputMaybe<VenueFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<VenueFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type VenueInput = {
  address?: InputMaybe<ComponentContactAddressInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type VenueRelationResponseCollection = {
  __typename?: 'VenueRelationResponseCollection';
  nodes: Array<Venue>;
};
